<template>
  <PrimeIconField>
    <PrimeInputIcon class="pi pi-spin pi-spinner" v-if="props.loading">
    </PrimeInputIcon>
    <PrimeTextarea
      v-model="value"
      v-bind="$attrs"
      class="w-full"
      @change="changeEventHandler($event)"
      @input="inputEventHandler($event)"
      @blur="blurEventHandler($event)"
      :disabled="loading || disabled"
      :invalid="hasErrors"
      :id="props.id"
      :placeholder="props.placeholder"
    />
  </PrimeIconField>
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    placeholder?: string;
  }>(),
  {
    disabled: false,
    loading: false,
  }
);

const value = defineModel<any>("value");

const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== ""){
    return true;
  }
  return false;
})

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

function changeEventHandler($event: any) {
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
